import React from 'react';
import PropTypes from 'prop-types';

export const IdCard = ({ width, height, ...props }) => (
  <svg
    data-icon='image'
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
    viewBox='0 0 32 32'
    {...props}
  >
    <path
      fill='currentColor'
      d='M18.667 17.333h6.667v-2.667h-6.667v2.667Zm0-4h6.667v-2.667h-6.667v2.667Zm-12 8h10.667V20.6c0-1-.49-1.795-1.467-2.384-.978-.588-2.267-.883-3.867-.883s-2.889.295-3.866.883c-.978.59-1.467 1.384-1.467 2.384v.733ZM12 16c.734 0 1.361-.261 1.884-.784.522-.522.783-1.15.783-1.883 0-.733-.261-1.361-.783-1.883A2.568 2.568 0 0 0 12 10.666c-.733 0-1.36.261-1.883.784a2.568 2.568 0 0 0-.783 1.883c0 .733.26 1.361.783 1.883.522.523 1.15.784 1.883.784ZM5.334 26.666a2.568 2.568 0 0 1-1.884-.783A2.568 2.568 0 0 1 2.667 24V8c0-.734.261-1.361.783-1.884a2.568 2.568 0 0 1 1.884-.783h21.333c.733 0 1.361.261 1.883.783.523.523.784 1.15.784 1.884v16c0 .733-.261 1.36-.784 1.883a2.568 2.568 0 0 1-1.883.783H5.334Zm0-2.666h21.333V8H5.334v16Z'
    />
  </svg>
);

IdCard.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

IdCard.defaultProps = {
  width: 32,
  height: 32,
};
